import request from 'utils/request'

/*---------  应收数据    -------*/
//获取table数据
export const getTableData = data =>
  request().post('customer/ar/aggregation/page', data)
//导出
export const exportCreditHistory = data =>
  request().post('customer/ar/export', data, {
    responseType: 'arraybuffer',
  })
// 获取单个totalAR数据
export const getYqData = data =>
  request().post('customer/ar/aggregation/detail ', data)
//获取数据
export const getLineChart = companyCode =>
  request().get(`customer/ar/getLineChart/${companyCode}`)
// 获取单个RMB数据
export const getRmbData = data =>
  request().post('customer/ap/aggregation/detail ', data)
